import ChatRoomPage from 'views/chatRoom/ChatRoomPage';

export default ChatRoomPage;
